import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/coach/");

  return (
    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
      <div className="sb-sidenav-menu">
        <div className="nav">
          <div className="sb-sidenav-menu-heading"></div>
          <Link
            className={url[1] === "dashboard" ? "nav-link active2" : "nav-link"}
            to="/coach/dashboard"
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            機能一覧
          </Link>
          <Link
            className={
              url[1] === "attendance" ? "nav-link active2" : "nav-link"
            }
            to="/coach/attendance"
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-list-alt"></i>
            </div>
            出席状況
          </Link>
        </div>
      </div>
      <div className="sb-sidenav-footer">
        <div className="small">としてログイン:</div>
        デモコーチ
      </div>
    </nav>
  );
};

export default Sidebar;
